import { Bars3Icon } from '@heroicons/react/24/solid';
import { useState } from 'react';

export default function Header() {
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <header className="flex justify-between items-center px-5 py-3 bg-primary text-white relative z-50">
      <a href="#" className="text-lg font-bold tracking-wider">
        G.Priyadharshni
      </a>

      {/* Desktop Menu */}
      <nav className="hidden md:block">
        <ul className="flex space-x-6 font-medium text-white">
          <li><a href="#hero" className="hover:text-pink-300 transition">Home</a></li>
          <li><a href="#about" className="hover:text-pink-300 transition">About</a></li>
          <li><a href="#certificates" className="hover:text-pink-300 transition">Achievements</a></li>
          <li><a href="#projects" className="hover:text-pink-300 transition">Projects</a></li>
          <li><a href="resume" className="hover:text-pink-300 transition">Resume</a></li>
          <li><a href="#contact" className="hover:text-pink-300 transition">Contact</a></li>
        </ul>
      </nav>

      {/* Mobile Menu Toggle Button */}
      <button
        onClick={() => setToggleMenu(!toggleMenu)}
        className="block md:hidden text-white focus:outline-none"
      >
        <Bars3Icon className="h-6 w-6" />
      </button>

      {/* Mobile Menu */}
      {toggleMenu && (
        <nav className="absolute top-full left-0 w-full bg-secondary text-white py-4 md:hidden shadow-lg">
          <ul className="flex flex-col items-center space-y-3 font-medium">
            <li><a href="#hero" onClick={() => setToggleMenu(false)}>Home</a></li>
            <li><a href="#about" onClick={() => setToggleMenu(false)}>About</a></li>
            <li><a href="#certificate" onClick={() => setToggleMenu(false)}>Achievements</a></li>
            <li><a href="#projects" onClick={() => setToggleMenu(false)}>Projects</a></li>
            <li><a href="resume" onClick={() => setToggleMenu(false)}>Resume</a></li>
            <li><a href="#contact" onClick={() => setToggleMenu(false)}>Contact</a></li>
          </ul>
        </nav>
      )}
    </header>
  );
}
